import React, { FunctionComponent, ReactNode, useContext } from 'react'
import { Portal, useIsBreakpointLargeAndUp } from '@afterpaytouch/core'
import { useDockedFooterElement } from '../../utils/dockedFooter'
import { TransitionContext } from '../PageTransition'

interface DockedFooterPortalProps {
  children: ReactNode
}

// TODO: extend to stick footer
export const DockedFooterPortal: FunctionComponent<DockedFooterPortalProps> = ({ children }) => {
  const { footerElement, isClient } = useDockedFooterElement()
  const isBreakpointLargeAndUp = useIsBreakpointLargeAndUp()
  const shouldUsePortal = footerElement !== null && isBreakpointLargeAndUp === false

  const transitionStatus = useContext(TransitionContext)
  const isTransitionComplete = transitionStatus === 'entered'

  if (!isClient || (shouldUsePortal && !isTransitionComplete)) {
    return null
  }

  return <>{shouldUsePortal ? <Portal container={footerElement}>{children}</Portal> : children}</>
}
